import { gql } from '@apollo/client';

export const ALL_COUNTRIES_QUERY_NAME = 'AllCountries';
export const ALL_COUNTRIES = gql`
    query ${ALL_COUNTRIES_QUERY_NAME}(
        $page: Int, 
        $perPage: Int,
        $sortKey: String,
        $sortDirection: String,
        $includeDeactivated: Boolean,
        $valueMapping: Map_String_List_MappedValueScalar,
    ) {
        allCountries(
            page: $page, 
            perPage: $perPage,
            sortKey: $sortKey,
            sortDirection: $sortDirection,
            includeDeactivated: $includeDeactivated,
            valueMapping: $valueMapping,
        ) {
            totalCount
            models {
                id
                name
                code
                active
                deactivationBlockers
                modificationBlockers {
                    blockerConstants
                    nonModifiableFields
                }
            }
        }
    }
`;

export const UPDATE_COUNTRY = gql`
    mutation UpdateCountry(
        $id: Int!, 
        $code: String!, 
        $name: String!, 
        $correlationId: String!
    ) {
        updateCountry(
            id: $id, 
            code: $code, 
            name: $name, 
            correlationId: $correlationId
        ) {
            name
            code
        }
    }
`;

export const CREATE_COUNTRY = gql`
    mutation CreateCountry(
        $code: String!, 
        $name: String!, 
        $correlationId: String!
    ) {
        createCountry(
            code: $code, 
            name: $name, 
            correlationId: $correlationId
        ) {
            id
            name
            code
        }
    }
`;

export const TOGGLE_COUNTRY_ACTIVATION = gql`
    mutation ToggleCountryActivation(
        $id: Int!,
        $correlationId: String!,
    ) {
        toggleCountryActivation(
            id: $id,
            correlationId: $correlationId,
        ) {
            name
            code
            active
        }
    }
`;

export const ON_COUNTRY_CHANGED = gql`
    subscription onCountryChanged {
        countryChanged {
            correlationId
            action
            model {
                id
                name
                code
            }
        }
    }
`;
